import { useTranslation } from 'react-i18next';
import { useSlateStatic } from 'slate-react';
import { Typography } from 'app/components/ui';
import { useTagNav } from 'app/state/contexts/TagContext';
import { removeExclude } from 'slate/extensions/tag';

export const ExcludePanel = () => {
  const { t } = useTranslation(['common', 'tag']);

  const editor = useSlateStatic();
  const { selectedExcludePath, setSelectedExcludePath } = useTagNav();

  if (!selectedExcludePath) return null;

  const handleRemove = () => {
    removeExclude(editor, selectedExcludePath);
    setSelectedExcludePath(null);
  };

  return (
    <section className="p-3 w-100">
      <Typography variant="body-7" fontWeight="light">
        {t('tag:exclude.panel.description')}
      </Typography>
      <div className="mt-2">
        <button className="btn btn-secondary" onClick={handleRemove}>
          {t('tag:exclude.remove')}
        </button>
        <button className="btn btn-link" onClick={() => setSelectedExcludePath(null)}>
          {t('common:cancel')}
        </button>
      </div>
    </section>
  );
};
